import Image from "next/image";
import check from "../../assets/images/upsc/check.png";
import styles from "./upsc-ias-ips-admission.module.css";
import handpointer from "../../assets/images/hand.svg";
import Link from "next/link";

const Program_Features = () => {
    return(
        <>

    <div className="container-fluid"
                style={{background: "transparent linear-gradient(180deg, #F4F6F8 0%, #F4F6F8 75%, #F4F6F800 100%) 0% 0% no-repeat padding-box", opacity: "1",}}>
                  <div className="container">                   
                    <div className="row text-center">
                        <div className="col-xl-6 col-lg-8 col-md-10 mx-auto text-start mb-5">
                        <h2 className={`${styles.featurecnt} pt-5`}>Program Features Of Our Foundation Course</h2>
                            <hr />
                            <div className="row">
                            <p className={`${styles.acheiverrank} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />Extensive coaching with more than 900 hours of classroom teaching</p>
                            <hr />
                            <p className={`${styles.acheiverrank} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />100+ hours of individual mentoring by experts</p>
                            <hr />
                            <p className={`${styles.acheiverrank} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />Extensive test series for prelims and mains</p>
                            <hr />
                            <p className={`${styles.acheiverrank} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />Comprehensive interview guidance program</p>
                            <hr />
                            <p className={`${styles.acheiverrank} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />Comprehensive study and reference materials</p>
                            <hr />
                        </div>
                        </div>

                        
                        <div className="col-xl-6 col-lg-8 col-md-10 mx-auto  text-start mb-5">
                        <h2 className={`${styles.featurecnt} pt-2 pt-md-5`}>Key Differentiators</h2>
                            <hr />
                            <div className="row">
                            <p className={`${styles.acheiverrank} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} /><Link href="/our-achievers" rel="noreferrer" target="_blank" className={`${styles.program}`}>Consistently producing toppers since 2004&nbsp;&nbsp;&nbsp;&nbsp;</Link></p>
                            <hr />
                            <p className={`${styles.acheiverrank} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} /><Link href="/our-faculty" rel="noreferrer" target="_blank" className={`${styles.program}`}>Experienced Faculty Team (10+ Years)&nbsp;&nbsp;&nbsp;&nbsp;</Link></p>
                            <hr />
                            <p className={`${styles.acheiverrank} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />Regular Guidance From Achievers</p>
                            <hr />
                            <p className={`${styles.acheiverrank} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />Scheduled interaction with bureaucrats (serving and retired)</p>
                            <hr />
                            <p className={`${styles.acheiverrank} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />Personalised and scientific mentoring</p>
                            <hr />
                        </div>
                        </div>
                      </div>
                  </div>
               </div>

        </>
    )
}
export default Program_Features;